/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Track_InvoicesInputs */

const en_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track your invoices`)
};

const de_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen verfolgen`)
};

const es_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento de tus facturas`)
};

const fr_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre vos factures`)
};

const nl_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg je facturen`)
};

const it_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia le tue fatture`)
};

const pt_br2_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhar suas faturas`)
};

const pl_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledź swoje faktury`)
};

const hu_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Számlák nyomon követése`)
};

const ro_admin_dashboard_track_invoices = /** @type {(inputs: Admin_Dashboard_Track_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urmariti facturile dumneavoastra`)
};

/**
* | output |
* | --- |
* | "Track your invoices" |
*
* @param {Admin_Dashboard_Track_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_track_invoices = /** @type {((inputs?: Admin_Dashboard_Track_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Track_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_track_invoices(inputs)
	if (locale === "de") return de_admin_dashboard_track_invoices(inputs)
	if (locale === "es") return es_admin_dashboard_track_invoices(inputs)
	if (locale === "fr") return fr_admin_dashboard_track_invoices(inputs)
	if (locale === "nl") return nl_admin_dashboard_track_invoices(inputs)
	if (locale === "it") return it_admin_dashboard_track_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_track_invoices(inputs)
	if (locale === "pl") return pl_admin_dashboard_track_invoices(inputs)
	if (locale === "hu") return hu_admin_dashboard_track_invoices(inputs)
	return ro_admin_dashboard_track_invoices(inputs)
});
export { admin_dashboard_track_invoices as "admin.dashboard.track_invoices" }